import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";

export const candidateColums = [
  {
    id: 1,
    candidateName: "John Doe",
    city: "New York",
    candidateStage: "Interview",
    modifyTime: "2024-03-06",
    source: "LinkedIn",
    candidateOwner: "Alice",
    rating: 3,
  },
  {
    id: 2,
    candidateName: "Ram Doe",
    city: "New York",
    candidateStage: "Interview",
    modifyTime: "2024-03-06",
    source: "LinkedIn",
    candidateOwner: "Alice",
    rating: 2,
  },
  {
    id: 3,
    candidateName: "John Doe",
    city: "New York",
    candidateStage: "Interview",
    modifyTime: "2024-03-06",
    source: "LinkedIn",
    candidateOwner: "Alice",
    rating: 1,
  },
];


export const candidateTabs = [
       { label: 'Candidate Details', Icon: JobOpeningIcon },
       { label: 'Cover Letter', Icon: DescriptionIcon },
]

export const location = ["Noida","Gurgaon","USA","Bangloare"]
export const totalExperience = ["3","5","6","7"]
export const noiticPeriod = ["1 month","15 days","immediate Joiner"]
export const status = ["Hired","Rejected","Pending"]
export const applicationSource = ["Naukari","shine","linkedin"]
